<template>
  <div class="comment-control">
    <v-menu
      v-if="
        (allowCommentAnswer || secondAllowCommentAnswer) &&
          isLoggedIn &&
          user &&
          (user.id === author ||
            (user.developer && user.developerIds.includes(developer) === true && user.roleDeveloper === true) ||
            user.roleAdmin === true)
      "
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on">
          {{ $t('Написать ответ') }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="item in answerItems"
          :key="item.id"
          @click="showCommentForm(item.id)"
        >
          <v-list-item-title>{{ item.transName }}</v-list-item-title>
        </v-list-item>
        <button class="btn-success" tabindex="0">OK</button>
      </v-list>
    </v-menu>
    <div class="comment-field" v-if="showForm">
      <div class="input-field">
        <ckeditor
          v-model="text"
          :editor="editor"
          :config="editorConfig"
          :placeholder="$t('Напишите ответ')"
        />
        <div class="comment-file">
          <input
            id="file"
            ref="file"
            type="file"
            class="hide"
            @change="handleFileUpload"
          />
          <a @click="changeFile">{{ $t('Прикрепите файл') }}</a>
          <div v-if="fileName">{{ fileName }} <span class="pro-icon-close" @click="deleteFile"></span></div>
          <div style="color: darkred;" class="file-link" v-if="fileError">{{ fileError }}</div>
        </div>
      </div>
      <div class="input-field action">
        <a @click.prevent="addCommentAnswer">{{ $t('Сохранить') }}</a>
        <a class="btn-cancel-link" @click.prevent="showForm = false">
          {{ $t('Отмена') }}
        </a>
      </div>
    </div>

    <!--ответ на комментарии-->
    <div class="comment-field" v-if="answers.length">
      <div class="response-comment">
        <div
          class="comment-item"
          v-for="(answer, index) in answers"
          :key="answer.id"
        >
          <div class="comment-head" :id="'answer_' + answer.id">
            <label>
              <b>{{ $t('Результат') }}:</b> {{ answer.result.transName }}
            </label>
            <br/>
            <label>
              <b>{{ $t('Ответ') }}:</b> <div v-html="answer.text"></div>
            </label>
            <label v-if="answer.file" style="display: flex; align-items: center;">
              <a
                v-if="answer.file"
                :href="baseUrl + answer.fullFilesDirectory"
                target="_blank"
                class="file-link mr-2"
              >
                <b>{{ $t('Приложенный файл') }}</b>
              </a>
              <span v-if="isLoggedIn && user && (user.id === author || user.roleAdmin === true)"
                    class="pro-icon-close"  @click="deleteCommentAnswerFile(answer.id)"></span>
            </label>
            <span style="display: flex; align-items: center;" v-else>
                <v-file-input
                  v-if="isLoggedIn && user && (user.id === author || user.roleAdmin === true)"
                  style="max-width: 30px"
                  id="answer-file"
                  v-model="answerFile"
                  dense
                  @change="addCommentAnswerFile(answer.id)"
                  :clearable="false"
                ></v-file-input>
              <label v-if="isLoggedIn && user && (user.id === author || user.roleAdmin === true)" class="file-link" for="answer-file">{{ $t('Прикрепить файл') }}</label>
            </span>
          </div>
          <div class="date">
            {{ new Date(answer.created) | dateFormat('DD.MM.YYYY HH:mm') }}
          </div>
          <div
            class="comment-status"
            v-if="
              (allowCommentAnswer || secondAllowCommentAnswer) &&
                isLoggedIn &&
                user &&
                (user.id === author ||
                  (user.developer && user.developerIds.includes(developer) === true && user.roleDeveloper === true) ||
                  user.roleAdmin === true)
            "
          >
            {{ $t('Статус') }}: {{ answer.status.transName }}
          </div>
          <div
            class="response-control"
            v-if="
              (allowCommentAnswer || secondAllowCommentAnswer) &&
                isLoggedIn &&
                user &&
                (user.id === author ||
                  (user.developer && user.developerIds.includes(developer) === true && user.roleDeveloper === true) ||
                  user.roleAdmin === true)
            "
          >
            <ul>
              <li
                v-if="
                  answer.status.id === hiddenAnswerStatusId ||
                    answer.status.id === unpublicAnswerStatusId
                "
              >
                <a
                  @click.prevent="
                    updateCommentAnswerStatus(
                      answer.id,
                      publicAnswerStatusId,
                      index
                    )
                  "
                >
                  {{ $t('Опубликовать') }}
                </a>
              </li>
              <li
                v-if="
                  answer.status.id === publicAnswerStatusId ||
                    answer.status.id === unpublicAnswerStatusId
                "
              >
                <a
                  @click.prevent="
                    updateCommentAnswerStatus(
                      answer.id,
                      hiddenAnswerStatusId,
                      index
                    )
                  "
                >
                  {{ $t('Скрыть с публикации') }}
                </a>
              </li>
              <li>
                <a
                  @click.prevent="
                    updateCommentAnswerStatus(
                      answer.id,
                      deleteAnswerStatusId,
                      index
                    )
                  "
                  class="btn-cancel-link"
                >
                  {{ $t('Удалить') }}
                </a>
              </li>
            </ul>
          </div>
          <hr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import {Trans} from "@/plugins/Translation"
import Search from "@/model/search"
// ckeditor
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading'

export default {
  name: 'NpaAnswers',
  props: {
    commentAnswers: Array,
    comment: Object,
    allowCommentAnswer: Boolean,
    secondAllowCommentAnswer: Boolean,
    author: Number,
    developer: Number
  },
  data() {
    return {
      editor: ClassicEditor,
      query: null,
      showForm: false,
      currentAnswerItemId: null,
      text: '',
      answers: this.commentAnswers,
      deleteItem: [
        'Спам',
        'Рекламные объявления',
        'Нецензурные выражения',
        'Другое'
      ],
      file: '',
      answerFile: null,
      baseUrl: process.env.VUE_APP_BACK_URL,
      fileName: '',
      fileError: null,
      allowedTypes: [
        'application/pdf',
        'application/x-pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        'image/bmp',
        'image/gif',
        'image/jpeg',
        'image/x-icon',
        'image/png',
        'image/pjpeg',
        'image/svg+xml',
        'image/tiff',
        'image/vnd.microsoft.icon',
      ],
      maxFileSize: 50 * 1024 * 1024,
      editorConfig: {
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          ParagraphPlugin,
          HeadingPlugin,
        ],
        toolbar: [
          'heading',
          '|',
          'bold',
          'italic',
          '|',
          'undo',
          'redo',
        ],
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            }
          ]
        }
      }
    }
  },
  computed: {
    answerItems() {
      return this.$store.state.getNpaData.answerItems
    },
    publicAnswerStatusId() {
      return this.$store.state.getNpaData.publicAnswerStatusId
    },
    hiddenAnswerStatusId() {
      return this.$store.state.getNpaData.hiddenAnswerStatusId
    },
    deleteAnswerStatusId() {
      return this.$store.state.getNpaData.deleteAnswerStatusId
    },
    unpublicAnswerStatusId() {
      return this.$store.state.getNpaData.unpublicAnswerStatusId
    },
    moderationCommentStatusId() {
      return this.$store.state.getNpaData.moderationCommentStatusId
    },
    // addUrl() {
    //   return `${Trans.currentLocale}/api/npaCommentAnswer/add/${this.comment.id}`
    // },
    user() {
      return this.$store.state.getNpaData.currentUser
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    showCommentForm(id) {
      this.currentAnswerItemId = id
      this.showForm = true
    },
    scrollAnswer() {
      if (!this.query) return
      const selector = `#answer_${this.query.answer}`
      this.$vuetify.goTo(selector)
    },
    hideCommentForm() {
      this.showForm = false
      this.text = ''
      this.file = ''
      this.answerFile = null
      this.fileName = ''
      this.currentAnswerItemId = null
    },
    async addCommentAnswer() {
      if (!this.text) {
        return
      }
      this.setLoading(true)

      // const formData = {
      //   text: this.text,
      //   result: this.currentAnswerItemId
      // }
      //
      let formData = new FormData()
      formData.append('npa_comment_answer[uploadedFile]', this.file)
      formData.append('npa_comment_answer[text]', this.text)
      formData.append('npa_comment_answer[result]', this.currentAnswerItemId)

      Search.addNpaCommentAnswer(this.comment.id, formData).then((response) => {
        this.answers.push(response.data.npaCommentAnswer)
        this.hideCommentForm()
      }).catch((error) => {
        console.error(error)
      })


      // try {
      //   const {data} = await this.$http.post(this.addUrl, formData)
      //
      // } catch (error) {
      //   console.error(error)
      // }
      this.setLoading(false)
    },

    async addCommentAnswerFile(id) {
      if (!this.answerFile) {
        return
      }
      this.setLoading(true)
      let formData = new FormData()
      formData.append('npa_comment_answer[uploadedFile]', this.answerFile)

      Search.addNpaCommentAnswerFile(id, formData).then((response) => {
        this.answers = this.answers.filter((item) => item.id !== id);
        this.answers.push(response.data.npaCommentAnswer)
        this.hideCommentForm()
      }).catch((error) => {
        console.error(error)
      })
      this.setLoading(false)
    },
    async deleteCommentAnswerFile(id) {
      this.setLoading(true)
      Search.deleteCommentAnswerFile(id).then((response) => {
        this.answers = this.answers.filter((item) => item.id !== id);
        this.answers.push(response.data.npaCommentAnswer)
        this.hideCommentForm()
      }).catch((error) => {
        console.error(error)
      })
      this.setLoading(false)
    },
    async updateCommentAnswerStatus(answerId, statusId, index) {
      this.setLoading(true)
      const url = `${Trans.currentLocale}/api/npaCommentAnswer/changeStatus/${answerId}/${statusId}`

      try {
        const {data} = await this.$http.post(url)
        if (statusId === this.deleteAnswerStatusId) {
          this.answers.splice(index, 1)
        } else {
          this.answers[index].status = data.commentAnswerStatus
        }
      } catch (error) {
        console.error(error)
      }
      this.setLoading(false)
    },
    changeFile() {
      this.$refs.file.click()
    },
    // handleFileUpload() {
    //   this.file = this.$refs.file.files[0]
    //   const fileInput = document.getElementById('file')
    //   this.fileName = fileInput.files[0].name
    // },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // Валидация типа файла
        if (!this.allowedTypes.includes(file.type)) {
          this.fileError = this.$t('Неверный тип файла.');
          this.deleteFile();
          return;
        }

        // Валидация размера файла
        if (file.size > this.maxFileSize) {
          this.fileError = this.$t('Размер файла слишком большой. Максимум 50MB.');
          this.deleteFile();
          return;
        }

        // Если файл прошёл валидацию
        this.fileName = file.name;
        this.fileError = null; // Сбрасываем ошибку
        this.file = file
      }
    },
    deleteFile() {
      this.file = ''
      this.fileName = ''
      this.$refs.file.value = ''
    }
  },
  mounted() {
    this.query = this.$route.query
    this.$nextTick(function () {
      if (this.query.answer) {
        this.scrollAnswer()
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.v-menu__content {
  background: #fff;
  border: 1px solid #9c9c9c;

  .v-list-item {
    min-height: 10px;
    padding: 5px 15px;

    &:hover {
      background: #bdebe9 !important;
    }

    .v-list-item__title {
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

.v-btn.v-size--default {
  height: auto;
  font-weight: 400;
  color: #004581;
  padding: 0px;
  box-shadow: none;
  text-transform: none;
  text-decoration: underline;
  letter-spacing: 0;

  &::before,
  &::after {
    display: none;
  }

  &:hover {
    text-decoration: none;
  }
}

.btn-success {
  float: right;
  background: #fff;
  font-weight: 500;
  font-size: 20px;
  color: #004581;
  padding: 10px 16px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
